import React, { useState, useEffect } from 'react';

// Import CSS & assets
import './Search.css';
import * as helpers from '../../../helpers/Other_helpers';
import { Filter_land_area, Filter_built_ground_area, Filter_land_compacity } from './filters';

// Import external functions
import * as map_helpers from '../../../components/app/map/Map_helpers';

// Import components
import ResultsList from './ResultsList';
import DoughnutChart from '../../charts/DoughnutChart';


const Search = ({ capacity, setCapacity, searchParameters, setSearchParameters, setIsFilterCatalogOpen, setHighlightedLand }) => {

    // Initiate search
    // useEffect(() => {
    //     if (capacity?.city?.title) {
    //         map_helpers.search_initiate(capacity, setSearchParameters);
    //     }
    // }, [capacity.city]);

    // Filters
    const handleFilterAdd = () => {
        setIsFilterCatalogOpen(true);
    }
    const filter_Delete = (filter_id) => {
        console.log("DELETE FILTER", filter_id);
        // Get current search
        var search = capacity?.search || { currentFiltersIds: [], currentFilters: {} };
        // Remove filter
        var currentFiltersIds_new = [];
        search.currentFiltersIds.forEach(element => {
            if (element !== filter_id) { currentFiltersIds_new.push(element) }
        });
        search.currentFiltersIds = currentFiltersIds_new;
        if (Object.keys(search.currentFilters).includes(filter_id)) {
            delete search.currentFilters[filter_id];
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__search");
        toSaveData.autoSave = false;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, search: search, toSave: toSaveData });
        // Update searchParameters
        var filters = searchParameters?.filters ? JSON.parse(JSON.stringify(searchParameters.filters)) : {};
        if (Object.keys(filters).includes(filter_id)) {
            delete filters[filter_id];
        }
        setSearchParameters({ ...searchParameters, filters: filters, map_update: ("-" + (Date.now()).toString()) });
    }

    // CHART
    const pieChartOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
                position: 'right',
                align: 'start'
            },
        },
        cutout: 40
    }
    var chartData = {
        labels: ['Retenues', 'Non retenues'],
        datasets: [
            {
                label: 'Parcelles',
                data: [searchParameters?.result_list?.list.length || 0, Math.max(0, (searchParameters?.nb_land - searchParameters?.result_list?.list.length)) || 0],
                backgroundColor: [
                    '#062134',
                    '#E5E5E5',
                ],
                hoverBackgroundColor: [
                    '#062134',
                    '#E5E5E5',
                ],
                borderColor: "#D9D9D9",
                hoverBorderColor: "#D9D9D9",
                borderWidth: 0,
                hoverBorderWidth: 0,
            },
        ],
    };

    return (
        <>
            {(searchParameters?.nb_land && capacity?.city?.title) ?
                <>
                    <div className="app__sectiondata_widget_title_container">
                        <div id="section_1_sector" className="app__sectiondata_widget_title">Secteur de recherche</div>
                    </div>
                    <div className="app__sectiondata_widget_layout_A">
                        <div className="app__sectiondata__widget" style={{ flex: 1 }}>
                            <div className="app__sectiondata_widget_title">Commune</div>
                            <div className="app__sectiondata_widget_value_text app__search_filters_city_label">{capacity.city.title}</div>
                            <div className="app__sectiondata_widget_value_legend">{capacity.city.postcode}</div>
                        </div>
                        {window.innerWidth > 550 &&
                            <div className="app__sectiondata__widget" style={{ width: '38%' }}>
                                <div className="app__sectiondata_widget_title">Nombre de parcelles</div>
                                <div className="app__sectiondata_widget_value_text">{searchParameters?.nb_land ? helpers.get_pretty_num(searchParameters?.nb_land) : "0"}</div>
                                <div className="app__sectiondata_widget_value_legend">parcelles au total</div>
                            </div>
                        }
                    </div>
                    <div className="app__sectiondata_widget_spacer"></div>
                    <div className="app__sectiondata_widget_title_container">
                        <div id="section_1_filters" className="app__sectiondata_widget_title">Critères de recherche</div>
                        {/* <div className="app__sectiondata_widget_layer">
                            <img src={ico_map_layers} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id="sectiondata_switch_rules" checked={mapLayers.rules.isVisible} onChange={() => { layer_Toggle("rules") }} /><label className="app__map_layer_checkbox_label" htmlFor="sectiondata_switch_rules">Toggle</label></div>
                        </div> */}
                    </div>
                    {searchParameters?.search_data_state === "done" &&
                        <>
                            <div className="app__search_filters_container">
                                {(!capacity?.search?.currentFiltersIds || capacity?.search?.currentFiltersIds.length === 0) &&
                                    <>
                                        <div className="app__search_filters_message_container">
                                            <div className="app__sectiondata_loading_text">Affinez votre recherche en ajoutant des critères</div>
                                        </div>
                                    </>
                                }
                                {/* LAND AREA */}
                                {(capacity?.search?.currentFiltersIds && capacity?.search?.currentFiltersIds.includes("land_area")) &&
                                    <Filter_land_area capacity={capacity} searchParameters={searchParameters} setSearchParameters={setSearchParameters} filter_Delete={filter_Delete} />
                                }
                                {/* LAND COMPACITY */}
                                {(capacity?.search?.currentFiltersIds && capacity?.search?.currentFiltersIds.includes("land_compacity")) &&
                                    <Filter_land_compacity capacity={capacity} searchParameters={searchParameters} setSearchParameters={setSearchParameters} filter_Delete={filter_Delete} />
                                }
                                {/* BUILT GROUND AREA */}
                                {(capacity?.search?.currentFiltersIds && capacity?.search?.currentFiltersIds.includes("built_ground_area")) &&
                                    <Filter_built_ground_area capacity={capacity} searchParameters={searchParameters} setSearchParameters={setSearchParameters} filter_Delete={filter_Delete} />
                                }
                                <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" style={{ marginRight: "8px" }} onClick={() => { handleFilterAdd() }}>Ajouter un critère</span></div>
                            </div>
                            {/* RESULT LIST */}
                            {searchParameters?.result_list?.list && searchParameters.result_list.list.length > 0 && searchParameters.result_list.list.length < searchParameters?.nb_land &&
                                <>
                                    <div className="app__sectiondata_widget_spacer"></div>
                                    <div className="app__sectiondata_widget_title_container">
                                        <div id="section_1_results" className="app__sectiondata_widget_title">Résultats de la recherche</div>
                                        {/* <div className="app__sectiondata_widget_layer">
                            <img src={ico_map_layers} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id="sectiondata_switch_rules" checked={mapLayers.rules.isVisible} onChange={() => { layer_Toggle("rules") }} /><label className="app__map_layer_checkbox_label" htmlFor="sectiondata_switch_rules">Toggle</label></div>
                        </div> */}
                                    </div>
                                    <div className="app__buidings_coef_body app__sectiondata__widget">
                                        {window.innerWidth > 500 &&
                                            <div className="app__search_chart">
                                                <div className="app__search_chart_value">
                                                    <div style={{ fontSize: "18px", fontWeight: "700", lineHeight: "20px" }}>{searchParameters.result_list.list.length}</div>
                                                    <div style={{ fontSize: "11px" }}>parcelles</div>
                                                </div>
                                                <DoughnutChart chartData={chartData} chartOptions={pieChartOptions} />
                                            </div>
                                        }
                                        <div className="app__buidings_coef_text">
                                            <div><strong>{searchParameters.result_list.list.length} parcelles</strong> correspondent aux critères définis.<br />Ce qui représente une <strong>sélection de {(100 * searchParameters.result_list.list.length / searchParameters.nb_land).toFixed(2)}%</strong> de toutes les parcelles de la commune.</div>
                                        </div>
                                    </div>
                                    <div className="app__sectiondata_widget_spacer_10"></div>
                                    <ResultsList searchParameters={searchParameters} setHighlightedLand={setHighlightedLand} />
                                </>
                            }
                            {/* {searchParameters?.result_list?.list && searchParameters.result_list.list.length === 0 && searchParameters?.filters && Object.keys(searchParameters.filters).length > 0 &&
                                <>
                                    <div className="app__sectiondata_widget_spacer"></div>
                                    <div className="app__sectiondata_widget_title_container">
                                        <div id="section_1_filters" className="app__sectiondata_widget_title" style={{ color: "transparent" }}>Résultats de la recherche</div>
                                    </div>
                                    <div className="app__search_filters_message_container">
                                        <div className="app__sectiondata_loading_text">Aucune parcelle ne correspond aux critères sélectionnés</div>
                                    </div>
                                </>
                            } */}
                        </>
                    }
                    {searchParameters?.search_data_state === "none" &&
                        <div>NO SEARCH DATA</div>
                    }
                </>
                :
                <>
                    <div className="app__sectiondata_loading_container_medium1">
                        <div className="app__sectiondata_loading_text">Sélectionnez une commune pour commencer la recherche foncière</div>
                        {/* <div className="combi__launch_button" onClick={() => { get_simulation() }}>Lancer le calcul des simulations</div> */}
                    </div>
                </>
            }
        </>
    );
};

export default Search;